import { FC, Table} from 'external/react'
import PaymentHistoryItem from './PaymentHistoryItem'

type HistoryTableProps = {
  invoices: Array<any>
}

const HistoryTable:FC<HistoryTableProps> = props => {

  const {invoices} = props

return (
  <Table striped bordered hover size='sm'>
    <thead>
      <tr>
        <th className='font-cell-text'>Fecha</th>
        <th className='font-cell-text'>Descripción</th>
        <th className='font-cell-text'>Periodo del servicio</th>
        <th className='font-cell-text'>Método de pago</th>
        <th className='font-cell-text'>Estado de pago</th>
        <th className='font-cell-text'>Total</th>
      </tr>
    </thead>
    <tbody>
      {invoices.map((item, index) => (<PaymentHistoryItem key={index} invoice={item} />))}
    </tbody>
  </Table>
	)
}

export {HistoryTable as default}